import dayjs from 'dayjs';

export const toApplicationDate = date => dayjs(date, 'MM/YYYY').format('YYYY-MM');
export const toDisplayDate = date => dayjs(date, 'YYYY-MM').format('MM/YYYY');
